import "./index.scss"
import quotation1 from "../../../../assets/quotation1.png"
import quotation2 from "../../../../assets/quotation2.png"
import more from "../../../../assets/circle.png"
function Evaluate() {
  const list = [
    {
      id: 1,
      title: "某合作银行的风控部门人员",
      content: "“再查查的数据很精准，能提前发现风险点，让我们在风控上更有把握，而且预警功能很实用，能提前提示风险，让我们能及时采取措施，对风险把控更有信心了，心里也踏实多了。”"
    },
    {
      id: 2,
      title: "某合作机构的业务部门人员",
      content: "“再查查帮我们节省了好多时间，以前找客户的经营情况等得花不少功夫，现在能直接一键查询，效率提升很明显，对业务拓展帮助很大，能快速筛选出有价值的财产线索，帮我们省了不少精力，业务推进更顺利了。”"
    },
    {
      id: 3,
      title: "某合作国央企的信息部门人员",
      content: "“再查查的数据资源很丰富，能快速帮我们找到关键信息，效率提升了一大截。”"
    },
    {
      id: 4,
      title: "某合作AMC机构的分析师",
      content: "“再查查系统里师爷AI一键尽调报告生成的功能非常方便且全面，报告质量有质的飞跃，为我们做决策提供了更可靠、详实的依据。”"
    },
    {
      id: 5,
      title: "某合作金融机构的数据科技部门人员",
      content: "“再查查的智能化程度很高，数据分析功能强大，帮我们省了不少时间和精力，而且接口很稳定，数据更新及时，跟我们系统对接起来很顺滑，省心不少。”"
    },
  ]
  return (
    <div className="evaluate-container">
      <div className="subtitle">客户评价</div>
      <div className="title">CUSTOMER EVALUATION</div>
      <img src={quotation1} className="quotation1"></img>
      <img src={quotation2} className="quotation2"></img>
      <div className="evaluate-info">
        {list.map((item, index) => {
          return (
            <div key={index} className="list-item">
              <div className="content-row">
                {item.content}
              </div>
              <div className="title-row">
                {item.title}
              </div>
            </div>
          )
        })}
        <div className="more">
          <img className="img" src={more}></img>
        </div>

      </div>

    </div>
  )
}
export default Evaluate